document.addEventListener('DOMContentLoaded', function() {
  // Variant selection handling
  var productForm = document.querySelector('[action*="/cart/add"]');
  var variantIdInput = document.querySelector('input[name="id"]');
  var optionSelects = document.querySelectorAll('.option-select');

  // Function to update cart count in header
  function updateCartCount(itemCount) {
    var cartCountElement = document.querySelector('.cart-count');
    if (cartCountElement) {
      cartCountElement.textContent = itemCount;
    }
  }

  // Handle add to cart form submission
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();

      var formData = new FormData(productForm);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) {
          console.error('Add to cart failed with status:', response.status);
          return response.text().then(text => {
            console.error('Error response:', text);
            throw new Error('Failed to add to cart: ' + response.status);
          });
        }
        return response.json();
      })
      .then(data => {
        console.log('Product added to cart:', data);
        // Get updated cart data
        return fetch('/cart.js');
      })
      .then(response => response.json())
      .then(cart => {
        // Update cart count in header
        updateCartCount(cart.item_count);

        // Open side cart if available
        if (window.sideCart) {
          window.sideCart.refresh().then(function() {
            window.sideCart.open();
          });
        }
      })
      .catch((error) => {
        console.error('Error adding to cart:', error);
        alert('Error adding to cart. Please try again.');
      });
    });
  }

  if (optionSelects.length > 0 && variantIdInput && window.productData && window.productData.variants && window.productData.options) {
    // Product variants data from global variable
    var productVariants = window.productData.variants;
    var productOptions = window.productData.options;

    // Function to find matching variant based on selected options
    function findMatchingVariant() {
      var selectedOptions = {};

      optionSelects.forEach(function(select) {
        var match = select.name.match(/options\[(.*?)\]/);
        if (!match || !match[1]) {
          return;
        }
        var optionName = match[1];
        selectedOptions[optionName] = select.value;
      });

      return productVariants.find(function(variant) {
        return variant.options.every(function(option, index) {
          var optionName = productOptions[index];
          return selectedOptions[optionName] === option;
        });
      });
    }

    // Update variant ID when options change
    function updateVariant() {
      var matchingVariant = findMatchingVariant();

      if (matchingVariant) {
        variantIdInput.value = matchingVariant.id;

        // Update price if needed
        var priceElement = document.querySelector('.product-price');
        if (priceElement && matchingVariant.price) {
          var formattedPrice = (matchingVariant.price / 100).toFixed(2);
          priceElement.textContent = '€' + formattedPrice;
        }

        // Update main image if variant has a featured image
        if (matchingVariant.featured_image) {
          var thumbnails = document.querySelectorAll('.thumbnail-item');

          // Find and click the matching thumbnail to trigger proper image switch
          thumbnails.forEach(function(thumb) {
            var thumbImageId = parseInt(thumb.getAttribute('data-image-id'));
            if (thumbImageId === matchingVariant.featured_image.id) {
              thumb.click();
            }
          });
        }
      }
    }

    // Add event listeners to all option selects
    optionSelects.forEach(function(select) {
      select.addEventListener('change', updateVariant);
    });
  }
});
